const subjects = [
    { value: "English", label: "English" },
  { value: "Math", label: "Math" },
  { value: "Art", label: "Art" },
  { value: "Science", label: "Science" },
  { value: "History", label: "History" },
  { value: "Music", label: "Music" },
  { value: "Geography", label: "Geography" },
  { value: "Physical Education", label: "Physical Education" },
  { value: "Drama", label: "Drama" },
  { value: "Biology", label: "Biology" },
  { value: "Chemistry", label: "Chemistry" },
  { value: "Physics", label: "Physics" },
  { value: "Computer Science", label: "Computer Science" },
  { value: "Foreign Languages", label: "Foreign Languages" },
  { value: "Social Studies", label: "Social Studies" },
  { value: "Technology", label: "Technology" },
  { value: "Philosophy", label: "Philosophy" },
  { value: "Graphic Design", label: "Graphic Design" },
  { value: "Literature", label: "Literature" },
  { value: "Algebra", label: "Algebra" },
  { value: "Geometry", label: "Geometry" }
]

  export default subjects;